import { Link } from "react-router-dom";
import causesData from "../../api/causes";
import SectionTitle from "../SectionTitle/SectionTitle";
import './CausesSecionS3.css';
import shape18 from "../../images/icons/shape-18.png"; 


const ClickHandler = () => {
    window.scrollTo(10, 0);
};

const CausesSecionS3 = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="causes-wrap">
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-md-12 col-12">
                            <SectionTitle subtitle="Stories of Hope" title="A Second Chance at Life" />
                            
                        </div>
                    </div>
                    <h5 style={{ fontSize:"25px", textAlign:"center", marginBottom:"25px"}} >Meet Eliana, a child whose future was restored after  
                    receiving free cardiac surgery she desperately needed.</h5>
          
                    <div className="arrow-shape"   style={{ backgroundImage: `url(${shape18})` }}></div>

                    <div className="row align-items-start">
                        {causesData.slice(0, 3).map((cause, cky) => (
                            
                            <div className="col col-lg-4 col-md-6 col-12" key={cky}>
                                                             {/* <span className="count-text">01</span> */}

                                <div className="causes-item insp-card">
                                    {/* <div className="img-frame"> */}
                                       
                                        <video autoPlay loop muted className=" bg-video img-frame">
                                            <source src={cause.video} ></source>
                                        </video>
                                    {/* </div> */}
                                    <div className="text-center">
                                        {/* <h3 className="cause-title"><Link onClick={ClickHandler} to={`/impact`}>{cause.title}</Link></h3> */}
                                        <p className="cause-sub">{cause.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                     
                     <div className="arrow-shape-2"   style={{ backgroundImage: `url(${shape18})` }}></div>

                    <div className="row align-items-start justify-content-center">
                        {causesData.slice(3, 5).map((cause, cky) => (
                            <div className="col col-lg-4 col-md-6 col-12" key={cky}>
                                <div className="causes-item insp-card">
                                    {/* <div className="img-frame"> */}
                                       
                                        <video autoPlay loop muted className=" bg-video img-frame">
                                            <source src={cause.video} ></source>
                                        </video>
                                    {/* </div> */}
                                    <div className="text-center">
                                        {/* <h3 className="cause-title"><Link onClick={ClickHandler} to={`/impact`}>{cause.title}</Link></h3> */}
                                        <p className="cause-sub">{cause.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="text-center mt-4">
                        <Link onClick={ClickHandler} to="/impact" className="theme-btn">See More Stories</Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CausesSecionS3; 